// removed by extract-text-webpack-plugin
module.exports = {"base":"Clan_base--1F7fQ","base__battle":"Clan_base__battle--2sNYh","baseBattle":"Clan_base__battle--2sNYh","emblem":"Clan_emblem--1q_GQ","logo":"Clan_logo--2zhRa","name":"Clan_name--2Tu4a","battle":"Clan_battle--1xwCF"};


//////////////////
// WEBPACK FOOTER
// ./components/Clan/Clan.scss
// module id = 404
// module chunks = 11 12